export default "__VITE_ASSET__ze5ae63Q__"